import React, { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter, Switch } from 'react-router-dom';
import { Route } from 'react-router-dom/cjs/react-router-dom.min';
import GlobalStyle from 'conf/style/GlobalStyle';
import theme from 'conf/style/theme';
import { routes } from 'consts';
import ContextProvider from 'context/Context';
import { ThemeProvider } from 'styled-components';

import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import Toast from 'components/Toast';

import Router from './router';

const queryClient = new QueryClient();

const Structure = () => (
  <Suspense fallback={<div>{' '}</div>}>
    <ErrorBoundary theme={theme}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <GlobalStyle />
            <Switch>
              <ContextProvider>
                <Router />
                <Toast />
                <Route path={routes?.notAuthorized.root}>
                  <ErrorBoundary theme={theme} />
                </Route>
              </ContextProvider>
            </Switch>
          </ThemeProvider>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen />
      </QueryClientProvider>
    </ErrorBoundary>
  </Suspense>
);

Structure.propTypes = {};
Structure.defaultProps = {};

export default Structure;
